import { getAuth } from "firebase/auth";
import React from "react";

import img1 from "../../../Assets/images/icons/teacher-icon-01.svg";
import img2 from "../../../Assets/images/icons/dash-icon-01.svg";
import img3 from "../../../Assets/images/icons/teacher-icon-02.svg";
import img4 from "../../../Assets/images/icons/teacher-icon-03.svg";
const Dashboard = () => {
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Page Header  */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <div className="page-sub-header">
                <h3 className="page-title">
                  Welcome {getAuth().currentUser.displayName + "!"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Parent</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Header  */}
        {/* Overview Section */}
        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-comman w-100">
              <div className="card-body">
                <div className="db-widgets d-flex justify-content-between align-items-center">
                  <div className="db-info">
                    <h6>Total Classes</h6>
                    <h3>04/06</h3>
                  </div>
                  <div className="db-icon">
                    <img src={img1} alt="Dashboard Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-comman w-100">
              <div className="card-body">
                <div className="db-widgets d-flex justify-content-between align-items-center">
                  <div className="db-info">
                    <h6>Total Students</h6>
                    <h3>40/60</h3>
                  </div>
                  <div className="db-icon">
                    <img src={img2} alt="Dashboard Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-comman w-100">
              <div className="card-body">
                <div className="db-widgets d-flex justify-content-between align-items-center">
                  <div className="db-info">
                    <h6>Total Lessons</h6>
                    <h3>30/50</h3>
                  </div>
                  <div className="db-icon">
                    <img src={img3} alt="Dashboard Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-comman w-100">
              <div className="card-body">
                <div className="db-widgets d-flex justify-content-between align-items-center">
                  <div className="db-info">
                    <h6>Total Hours</h6>
                    <h3>15/20</h3>
                  </div>
                  <div className="db-icon">
                    <img src={img4} alt="Dashboard Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Overview Section */}
      </div>
    </div>
  );
};

export default Dashboard;
